import FootballStringifier from "../../../../services/stringifiers/football-stringifier";
import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class SkipKickoff extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.SkipKickoff;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { summaryContext } = FootballStringifier.generateSummary(
            play,
            gameContext
        );
        const { homeTeamHasPossession, awayTeamId, homeTeamId } =
            summaryContext;
        const driveTeamId = homeTeamHasPossession ? awayTeamId : homeTeamId;

        gameContext.setPossessionForTeamId(driveTeamId);
        gameContext.setFieldPosition(fragment.fieldPosition);
        ruleContext.setAwardFirstDown(true);
        gameContext.setDriveContext({
            triggerDrive:
                gameContext.homeTeamHasPossession !==
                play.contextSnapshot.homeTeamHasPossession
        });
    }
}
